import type { SetupStepComponent } from '..'

import Section from '../../components/section'

const PostHirelingSetupStep: SetupStepComponent = () => (
  <Section
    subtitleKey="setupStep.postHirelingSetup.subtitle"
    textKey="setupStep.postHirelingSetup.body"
  />
)

export default PostHirelingSetupStep
